import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'

import logo from "../images/dlpl_logo.png";
import drlalpathlab from "../images/home_banner_first1.webp";
import drlalpathlabpackage from "../images/Routine-Packages.webp";


function Labtest() {
  const [setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showPerPage, setShowPerPage] = useState(2500);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [searchTerm, setsearchTerm] = useState("");
  const [labtest, setLabtest] = useState([])
  const navigate = useNavigate()

  const labtestCollectionRef = collection(db, "Labtest");
  useEffect(() => {

    const getLabtest = async () => {
      const data = await getDocs(labtestCollectionRef);
      setLabtest(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }

    getLabtest()
  }, [])
  return (

    <>
    

      <div className="album py-2">

        <div className="container">

          <div className="row">
 <div className="col-md-6 mt-2">
              <img src={drlalpathlabpackage} className="d-block w-100" alt="drlalpathlabkrishnagar"/>

            </div>
            <div className="col-md-6 mt-2">

              <div className="card-body">
                <input type="text" className="form-control" placeholder="Search" name="location"
                  onChange={(e) => {
                    setsearchTerm(e.target.value);
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">




                </div>


              </div>


            </div>
           

          </div>

        </div>
      </div>


      <div className="album py-1">

        <div className="container">

          <div className="row">
            {labtest.filter((val) => {
              if (setsearchTerm === "") {
                return val;
              } else if (
                val.name.toLowerCase().includes(searchTerm.toLowerCase())


              ) {
                return val;
              }
            }).slice(pagination.start, pagination.end).map((elitemedicalcare) => {
              return (
                <div className="col-md-4 mt-3" >
                  <div className="card mb-2 shadow">
                    {/* <img  className="card-img-top" src={elitemedicalcare.Img}  alt="labtest"/> */}
                    <div className="card-body">
                      <div className="textcolor">
                        <h6 className="card-text"> <b>{elitemedicalcare.name}</b></h6>
                      </div>
                      <p className="card-text">{elitemedicalcare.para}</p>
                      <div className="d-flex justify-content-start align-items-center mb-0">
                        <p className='mb-0 me-5'><b>Report Delivery:</b></p>

                        <img src={logo} width="120px" height="34px" alt="logo" />
                      </div>
                      <p style={{ color: "grey" }} className="card-text mb-2"><small>{elitemedicalcare.delivery}</small></p>

                      <h6 className='mb-2' style={{ color: "darkBlue" }}> ₹ {elitemedicalcare.price}</h6>
                      <div className="d-flex justify-content-between align-items-center">
                        <a href='tel: 9732775201' className="callbook mb-1">Call Book</a>

                      </div>

                    </div>

                  </div>

                </div>

              )
            })}
          </div>

        </div>
        <br />

      </div>

    </>

  );
}

export default Labtest;



